exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-content[data-v-3a2726bc]{width:1200px;margin:88px auto 0;padding-bottom:114px}.list-content .list-more[data-v-3a2726bc]{width:100%;font-size:22px;color:#333;font-weight:500}.list-content .list-inner .list-box[data-v-3a2726bc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:20px;border-top:1px solid #ebebeb;width:100%}.list-content .list-inner .pagination[data-v-3a2726bc]{margin-top:60px}", ""]);

// exports
